export enum ElectronicDocumentEnums {
  //Tipo Dian:
  tipoDianFacturaVenta = 1,
  tipoDianFacturaExportacion = 2,
  tipoDianFacturaContigencia = 3,
  tipoDianNotaCredito = 4,
  tipoDianNotaDebito = 5,
  tipoDianDocumentoSoporte = 6,
  tipoDianNotaAjusDocumSoporte = 7
}

export enum StatusDianEnums {
  //Estados Dian:
  rechazado = 0,
  aprobado = 1,
  pendiente = 2
}